const Spinner = () => {
  return (
    <div className="fixed inset-0 bg-black/20 flex items-center justify-center z-50">
      <div className="deputy-loader"></div>
    </div>
  );
};

export default Spinner;
